import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from "../../../../Context/Context";
import { Menu } from "../Menu";
import { MenuLateral } from "../MenuLateral";
import './tailwind.css';

export const EasyTracking = () => {
    const id = atob(sessionStorage.getItem("dtpln"));
    const [state, setState] = useContext(AppContext);
    const [isLineaVisible, setLineaVisible] = useState(true);
    const [activeTab, setActiveTab] = useState('administrativo');
    const [administrativeSteps, setAdministrativeSteps] = useState([]);
    const [logisticSteps, setLogisticSteps] = useState([]);
    const [selectedStep, setSelectedStep] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const [stepsAdministrativosEnabled, setStepsAdministrativosEnabled] = useState(false);
    const [stepsLogisticosEnabled, setStepsLogisticosEnabled] = useState(false);
    const [planModel, setPlanModel] = useState(null);
    const [errorMsg, setErrorMsg] = useState('');
    const [showButtons, setShowButtons] = useState(true);
    const [isFetchingSteps, setIsFetchingSteps] = useState(true);

    useEffect(() => {
        const plan = state.plan;

        if (plan) {
            setPlanModel(plan.ModeloAhorro);
        }

        setStepsAdministrativosEnabled(state.stepsAdministrativosEnabled === true);
        setStepsLogisticosEnabled(state.stepsLogisticosEnabled === true);

        if (!state.stepsAdministrativosEnabled && state.stepsLogisticosEnabled) {
            setActiveTab('logistico');
        }

        const asyncFunction = async () => {
            try {
                setIsFetchingSteps(true);
                const tokenLogin = atob(sessionStorage.getItem('dttk'));
                const cuit = atob(sessionStorage.getItem("dtdc"));
                const contractNumber = plan.Solicitud;
                const response = await fetch(`/api/get_easy_tracking?contract=${contractNumber}&cuit=${cuit}&tokenLogin=${tokenLogin}`);

                if (!response.ok) {
                    const errorData = await response.json();
                    setErrorMsg(errorData.errorMsg || errorData.error);
                    setShowButtons(false);
                    return;
                }


                const json = await response.json();
                setIsFetchingSteps(false);

                if (json && json.administrativeStepsList) {
                    setAdministrativeSteps(json.administrativeStepsList);
                }

                if (json && json.logisticsStepsList) {
                    setLogisticSteps(json.logisticsStepsList);
                }

            } catch (error) {
                console.error('There was a problem with the fetch operation:', error);
            }
        }
        asyncFunction();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleLinea = () => {
        setLineaVisible(!isLineaVisible);
    };

    const getLastConcludedStep = () => {
        const steps = activeTab === 'administrativo' ? administrativeSteps : logisticSteps;
        return steps.slice().reverse().find(step => step.concluded);
    };

    const lastConcludedStep = getLastConcludedStep();

    const showTab = (tabName) => {
        setActiveTab(tabName);
        setSelectedStep(null);
    };

    const handleStepClick = (step) => {
        setSelectedStep(step);
    };

    function processText(inputText) {
        if (inputText == null) {
            return "";
        }

        const text = inputText.toLowerCase();
        if (text.includes("click aca") || text.includes("click acá")) {
            return convertClickAcaToLink(inputText);
        } else if (text.includes("acá")) {
            return handleAcaText(inputText);
        } else {
            return convertTextToLink(inputText);
        }
    }

    function handleAcaText(text) {
        const regex = /(acá)(.*?)((https?:\/\/\S+))/ig;
        let parts = [];
        let lastIndex = 0;

        text.replace(regex, (match, acaText, intermediateText, url, offset) => {
            if (offset > lastIndex) {
                parts.push(text.substring(lastIndex, offset));
            }
            parts.push(
                <a key={offset} href={url} target="_blank" rel="noopener noreferrer" style={{ color: 'blue' }}>
                    {acaText}
                </a>
            );
            parts.push(intermediateText);
            lastIndex = offset + match.length;
        });
        if (lastIndex < text.length) {
            parts.push(text.substring(lastIndex));
        }

        return <>{parts.map((part, index) => <React.Fragment key={index}>{part}</React.Fragment>)}</>;
    }


    function convertClickAcaToLink(text) {
        const regex = /(click\s+)(a[ck]á?)(.*?\s)(https?:\/\/\S+)/ig;
        let parts = [];
        let lastIndex = 0;

        text.replace(regex, (match, clickText, acaText, intermediateText, url, offset) => {
            if (offset > lastIndex) {
                parts.push(text.substring(lastIndex, offset));
            }
            parts.push(clickText);
            parts.push(
                <a key={offset} href={url} target="_blank" rel="noopener noreferrer" style={{ color: 'blue' }}>
                    {acaText}
                </a>
            );
            parts.push(intermediateText);
            lastIndex = offset + match.length;
        });
        if (lastIndex < text.length) {
            parts.push(text.substring(lastIndex));
        }
        return <>{parts.map((part, index) => <React.Fragment key={index}>{part}</React.Fragment>)}</>;
    }

    function convertTextToLink(text) {
        const urlRegex = /(\bhttps?:\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        const parts = text.split(urlRegex);

        return parts.map((part, index) => {
            if (part.match(urlRegex)) {
                return <a key={index} href={part} target="_blank" rel="noopener noreferrer" style={{ color: 'blue' }}>{part}</a>;
            } else {
                return <span key={index}>{part}</span>;
            }
        });
    }

    return (
        <div>
            <Menu />
            <div className="wrap">
                <MenuLateral key={state.selectedPlan?.Id || "default-key"} />
                <div className="next-to-sidebar">
                    <div className="container m-auto" style={{ position: 'relative', paddingTop: '55px' }}>
                        <div className="bg-[#A31445] text-center">
                            <div className="text-white p-3" style={{ fontWeight: 'bold' }}>
                                {errorMsg
                                    ? 'Easy Tracking no disponible para planes de ahorro de esta antigüedad.'
                                    : isFetchingSteps
                                        ? 'Obteniendo estado...'
                                        : ((activeTab === 'administrativo' && !administrativeSteps.length) || (activeTab === 'logistico' && !logisticSteps.length))
                                            ? 'Estado de Plan: N/D'
                                            : `Estado de Plan: ${lastConcludedStep ? lastConcludedStep.name : 'Obteniendo estado...'}`}
                            </div>
                            <div className="h-0.5 w-3/4 bg-white m-auto"></div>
                            <div className="text-white p-3 flex items-center justify-center cursor-pointer" onClick={toggleLinea}>
                                <p className="mr-2">Desplegar línea de tiempo</p>
                                <svg className={`w-5 ${isLineaVisible ? 'transform rotate-180' : ''}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.71 13.39">
                                    <path d="m21.37.29-10.51 12.4L.34.29" style={{ fill: 'none', stroke: '#fff', strokeMiterlimit: 10, strokeWidth: '.9px' }} />
                                </svg>
                            </div>
                        </div>

                        {isLineaVisible && (
                            <div id="lineadetiempo">
                                <div className="flex justify-center items-center gap-6 bg-gray-300 pt-6">
                                    {stepsAdministrativosEnabled && showButtons && (
                                        <div
                                            className={`w-48 h-8 border-2 border-[#A31445] transform -skew-x-12 flex justify-center items-center cursor-pointer ${activeTab === 'administrativo' ? 'bg-[#A31445] text-white' : 'text-[#A31445]'}`}
                                            onClick={() => showTab('administrativo')}
                                        >
                                            <p className="text-lg normal-case">Administrativo</p>
                                        </div>
                                    )}
                                    {stepsLogisticosEnabled && showButtons && (
                                        <div
                                            className={`w-48 h-8 border-2 border-[#A31445] transform -skew-x-12 flex justify-center items-center cursor-pointer ${activeTab === 'logistico' ? 'bg-[#A31445] text-white' : 'text-[#A31445]'}`}
                                            onClick={() => showTab('logistico')}
                                        >
                                            <p className="text-lg normal-case">Logístico</p>
                                        </div>
                                    )}
                                </div>
                                {errorMsg && <div className="flex justify-center items-center gap-6 bg-gray-300 pt-6" style={{ paddingTop: '60px' }}>{errorMsg}</div>}

                                {activeTab === 'administrativo' && stepsAdministrativosEnabled && (
                                    <div id="administrativo">
                                        <section className="w-full py-12 relative bg-gray-300">
                                            <div className="container flex flex-col md:flex-row items-center">
                                                {administrativeSteps.map((step, index) => {
                                                    const lastConcludedIndex = administrativeSteps.map(step => step.concluded).lastIndexOf(true);
                                                    const isLastConcludedStep = index === lastConcludedIndex;
                                                    const isAfterLastConcluded = index > lastConcludedIndex;

                                                    return (
                                                        <div key={step.sequence} className="mt-6 flex md:flex-col lg:flex-col items-center relative" style={{ flexGrow: 1, alignSelf: isMobile ? 'start' : 'center', cursor: 'pointer' }} onClick={() => handleStepClick(step)}>
                                                            {/* Lines behind the circles */}
                                                            <div className={`absolute left-0 h-0.5 bg-black ${isAfterLastConcluded ? 'border-dashed border-2' : ''}`} style={{ top: isLastConcludedStep ? '17.3%' : '13%', right: '50%', left: '-4%', zIndex: 1, visibility: isMobile ? 'hidden' : 'visible' }}></div>
                                                            <div className={`absolute right-0 h-0.5 bg-black ${isLastConcludedStep ? 'border-dashed border-2' : (isAfterLastConcluded ? 'border-dashed border-2' : '')}`} style={{ top: isLastConcludedStep ? '17.3%' : '13%', left: '50%', zIndex: 1, visibility: isMobile ? 'hidden' : 'visible' }}></div>

                                                            {/* Circle */}
                                                            <div className={`w-${isLastConcludedStep ? '12' : '8'} h-${isLastConcludedStep ? '12' : '8'} rounded-full border-2 ${step.concluded ? 'border-[#A31445]' : 'border-black'} bg-gray-300 flex items-center justify-center`} style={{ zIndex: 2 }}>
                                                                {step.concluded && (
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width={isLastConcludedStep ? "24" : "16"} height={isLastConcludedStep ? "24" : "16"} viewBox="0 0 24 24" fill="none" stroke="#A31445" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                                    </svg>
                                                                )}
                                                            </div>

                                                            {/* Step name - right side on mobile, below on full resolution */}
                                                            <div className={`text-sm ${isLastConcludedStep ? 'font-bold' : ''} md:mt-2 md:text-center sm:ml-2 md:ml-0`} style={{ height: isMobile ? '42px' : '80px', maxWidth: isMobile ? '250px' : '100px', overflow: 'hidden', textAlign: 'center', display: isMobile ? 'flex' : 'inline', alignItems: 'center', marginLeft: isMobile ? '20px' : '0px' }}>
                                                                {step.name}
                                                            </div>
                                                        </div>
                                                    );
                                                })}



                                            </div>
                                        </section>
                                    </div>
                                )}
                                {activeTab === 'logistico' && stepsLogisticosEnabled && (
                                    <div id="logitico">
                                        <section className="w-full py-12 relative bg-gray-300">
                                            <div className="container flex flex-col md:flex-row items-center">
                                                {logisticSteps.map((step, index) => {
                                                    const lastConcludedIndex = logisticSteps.map(step => step.concluded).lastIndexOf(true);
                                                    const isLastConcludedStep = index === lastConcludedIndex;
                                                    const isAfterLastConcluded = index > lastConcludedIndex;

                                                    return (
                                                        <div key={step.sequence} className="mt-6 flex md:flex-col lg:flex-col items-center relative" style={{ flexGrow: 1, alignSelf: isMobile ? 'start' : 'center' }} onClick={() => handleStepClick(step)}>
                                                            {/* Lines behind the circles */}
                                                            <div className={`absolute left-0 h-0.5 bg-black ${isAfterLastConcluded ? 'border-dashed border-2' : ''}`} style={{ top: isLastConcludedStep ? '17.3%' : '13%', right: '50%', zIndex: 1, visibility: isMobile ? 'hidden' : 'visible' }}></div>
                                                            <div className={`absolute right-0 h-0.5 bg-black ${isLastConcludedStep ? 'border-dashed border-2' : (isAfterLastConcluded ? 'border-dashed border-2' : '')}`} style={{ top: isLastConcludedStep ? '17.3%' : '13%', left: '50%', zIndex: 1, visibility: isMobile ? 'hidden' : 'visible' }}></div>

                                                            {/* Circle */}
                                                            <div className={`w-${isLastConcludedStep ? '12' : '8'} h-${isLastConcludedStep ? '12' : '8'} rounded-full border-2 ${step.concluded ? 'border-[#A31445]' : 'border-black'} bg-gray-300 flex items-center justify-center`} style={{ zIndex: 2 }}>
                                                                {step.concluded && (
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width={isLastConcludedStep ? "24" : "16"} height={isLastConcludedStep ? "24" : "16"} viewBox="0 0 24 24" fill="none" stroke="#A31445" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                                    </svg>
                                                                )}
                                                            </div>

                                                            {/* Step name - right side on mobile, below on full resolution */}
                                                            <div className={`text-sm ${isLastConcludedStep ? 'font-bold' : ''} md:mt-2 md:text-center sm:ml-2 md:ml-0`} style={{ height: isMobile ? '32px' : '80px', maxWidth: isMobile ? '250px' : '100px', overflow: 'hidden', textAlign: 'center', display: isMobile ? 'flex' : 'inline', alignItems: 'center', marginLeft: isMobile ? '20px' : '0px' }}>
                                                                {step.name}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </section>
                                    </div>
                                )}
                            </div>
                        )}
                        <div className="inicio_mainDiv--user" style={{ marginTop: '40px' }}>
                            <p>{planModel}</p>
                            <div className="separator--hor mt-half mb-half"></div>
                        </div>
                        <p><b>{selectedStep ? selectedStep.name : ''}</b></p>
                        <p style={{ marginTop: '15px', whiteSpace: 'break-spaces' }}>{selectedStep ? processText(selectedStep.messageClient) : ''}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
